import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Button } from "../../../catalyst-components/button";
import { Textarea } from "../../../catalyst-components/textarea";
import { Field } from "../../../catalyst-components/fieldset";

interface Props {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export const EvergreenInput: React.FC<Props> = ({ onSend, disabled }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-resize textarea based on content
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input]);

  // Focus input when not disabled
  useEffect(() => {
    if (!disabled) {
      textareaRef.current?.focus();
    }
  }, [disabled]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim() && !disabled) {
      onSend(input);
      setInput("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form className="pb-[calc(1rem+env(safe-area-inset-bottom))] fixed bottom-0 left-0 right-0 bg-background border-t border-border/30 pt-4" onSubmit={handleSubmit}>
      <div className="max-w-4xl mx-auto px-6">
        <Field>

          <section className="flex gap-3 items-end">
            <Textarea
              ref={textareaRef}
              name="user_input"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={disabled}
              placeholder={t('chatInput.placeholder')}
              className="flex-1"
              style={{
                minHeight: '2.5rem',
                maxHeight: '14rem',
                resize: 'none',
                overflowY: 'auto'
              }}
            />
            <Button
              color="primary"
              type="submit"
              className="h-10 w-10 min-w-10 flex-shrink-0 rounded-full !p-0 flex items-center justify-center"
              disabled={!input.trim() || disabled}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-white">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
              </svg>
            </Button>
          </section>
        </Field>
      </div>
    </form>
  );
};
